import { apiRequest } from "../util/apiUtils";

export const organizationList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const organizationFrontList = async (params) => {
  try {
    const res = await apiRequest("get", `organization/front-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationDetailsUser = async (payload) => {
  try {
    const res = await apiRequest(
      "get",
      `/organization/front-detail/${payload?.slug}`,
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationAboutUser = async (payload) => {
  try {
    const res = await apiRequest(
      "get",
      `/organization/front-detail/${payload?.slug}/about`,
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const organizationJobUser = async (payload) => {
  try {
    const res = await apiRequest(
      "get",
      `/organization/front-detail/${payload?.slug}/job`,
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const organizationAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `organization/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data",
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `/organization/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `organization/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `organization/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
